import { commandType } from "./Attributes";

export const Skeleton = {
    type: commandType,
    settings: {
        yaw: "",
    },
};
